"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const global_1 = require("./global");
const ng_snotify_1 = require("ng-snotify");
const core_1 = require("@ngx-translate/core");
const app_dialog_1 = require("./dialogs/app-dialog");
const map_dialog_1 = require("./dialogs/map-dialog");
const map_dialog_plot_all_1 = require("./dialogs/map-dialog-plot-all");
const FourDInjector_1 = require("./FourDInjector");
const Constants_1 = require("./Constants");
const epsgcode_dialog_component_1 = require("./dialogs/epsgcode/epsgcode-dialog.component");
const identify_interface_1 = require("../xs/interfaces/identify.interface");
const event_listener_interface_1 = require("../xs/interfaces/event-listener.interface");
const plugin_manager_service_1 = require("../service/plugin-manager.service");
const Cesium = window.Cesium;
/*
    BaseComponent
    -------------
    Meant to be the core component, not DI, so mostly technical stuff that doesn't use any other components or helpers.
    It's also the base, base, base component, so all components, not just the annotation stuff, uses this one.

  */
class BaseComponent {
    constructor(router, snackBar, dialog) {
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.debug = Constants_1.Constants.debug_off;
        this.debugMe = null;
        this.debugPrimary = Constants_1.Constants._gray;
        this.debugSecondary = Constants_1.Constants._white;
        this.debugBase = false;
        this.__ID = null;
        this.__EVENTS = null;
        this.loading = false;
        this.routes = global_1.AppRoutes;
        this._subs = [];
        this.appConstants = global_1.AppConstants;
        this.pluginManager = null;
        // our mouse handler
        this.mouseHandler = null;
        // the cursor for creating a new annotation
        this.mouseCursor = null;
        // current interaction mode (for whatever component is in control)
        this.interactionMode = 'select';
        // a flag for whether we're currently dragging somerthing around
        this.isDragging = false;
        // any shapes inside this annotation
        this.shapes = [];
        // plugins
        this.plugin = null;
        // a handy helper-class for state and ghosts (artefacts for drawing, like handles and dotted lines)
        this.shapeMaker = null;
        // calculating variables
        // how far have we come?
        this.percentFinished = 0;
        // can this component calculate anything? (area, volume, etc.)
        this.canCalculate = false;
        this.canCalculateVolume = false;
        this.autoCalculate = false;
        this.calculating = false;
        this.currentCalc = 0;
        this.totalCalc = 1;
        // key masks
        this.masks = {};
        this.checkMobileCounter = 9999;
        this.currentSize = 0;
        this.debugMe = this.constructor.name;
        if (this.debugBase) {
            console.log('%c base.comp [' + this.debugMe + '] %c constructor', Constants_1.Constants._green, Constants_1.Constants._black);
        }
        this.snotifyService = FourDInjector_1.FourDInjector.injector.get(ng_snotify_1.SnotifyService);
        this.translate = FourDInjector_1.FourDInjector.injector.get(core_1.TranslateService);
        this.pluginManager = FourDInjector_1.FourDInjector.injector.get(plugin_manager_service_1.PluginManagerService);
        // if ( this.debug ) { console.log ( '%c base.comp ['+this.debugMe+'] %c constructor END', Constants._yellow, Constants._yellow, this.snotifyService, this.translate ); }
    }
    _buggy(id, msg = null, ...args) {
        if (this.debug) {
            console.log('%c [' + this.debugMe + '] %c ' + id + '()' + (msg ? ' / ' + msg : ''), this.debugPrimary, this.debugSecondary, ...args);
        }
    }
    // this components various subscriptions to events
    addSubscription(id, f) {
        if (this.debugBase) {
            console.log('%c base.comp [' + this.debugMe + '] %c addSubscription(' + id + ')', Constants_1.Constants._yellow, Constants_1.Constants._yellow, f);
        }
        this._subs.push(f);
    }
    // delete all of them
    deleteSubscriptions() {
        if (this.debugBase) {
            console.log('%c base.comp [' + this.debugMe + '] %c deleteSubscriptions()', Constants_1.Constants._green, Constants_1.Constants._black, this._subs.length);
        }
        this._subs.forEach(sub => sub.unsubscribe());
    }
    __xs_start() {
        this.__ID = identify_interface_1.XsIdentityInterface.__init(this);
        this.__EVENTS = event_listener_interface_1.XsEventListenerInterface.__init(this);
        if (this.debugBase) {
            console.log('%c base.comp [' + this.debugMe + '] %c __xs_start()', Constants_1.Constants._green, Constants_1.Constants._black, this.__ID.instance);
        }
    }
    __xs_end() {
        if (this.debugBase) {
            console.log('%c base.comp [' + this.debugMe + '] %c __xs_end()', Constants_1.Constants._green, Constants_1.Constants._black);
        }
        event_listener_interface_1.XsEventListenerInterface.__destroy(this);
    }
    ngOnInit() {
        if (this.debugBase) {
            console.log('%c base.comp [' + this.debugMe + '] %c ngOnInit()', Constants_1.Constants._green, Constants_1.Constants._black);
        }
        // set up unique identifiers and event handlers
        this.__xs_start();
        // finally init (overridable)
        this.init();
    }
    init() {
        if (this.debugBase) {
            console.log('%c base.comp [' + this.debugMe + '] %c init()', Constants_1.Constants._green, Constants_1.Constants._black);
        }
    }
    // default destroyer just calls the deleteSubscriptions. If you provide your own, 
    // remember to call deleteSubscriptions() yourself or call super
    ngOnDestroy() {
        if (this.debugBase) {
            console.log('%c base.comp [' + this.debugMe + '] %c ngOnDestroy()', Constants_1.Constants._green, Constants_1.Constants._black);
        }
        this.deleteSubscriptions();
        this.destroy();
        this.__xs_end();
    }
    destroy() {
        if (this.debugBase) {
            console.log('%c base.comp [' + this.debugMe + '] %c destroy()', Constants_1.Constants._green, Constants_1.Constants._black);
        }
    }
    // method for components to override if they've got calculations
    calculate() { }
    keyUp(e) {
        delete this.masks[e.keyCode];
        if (e.keyCode == 17 || e.keyCode == 224 || e.keyCode == 91) {
            delete this.masks['ctrl'];
        }
        if (e.keyCode == 18) {
            delete this.masks['alt'];
        }
        if (e.keyCode == 16) {
            delete this.masks['shift'];
        }
    }
    keyDown(e) {
        // delete or backspace
        if (e.keyCode == 46 || e.keyCode == 110 || e.keyCode == 8) {
        }
        else if ((e.ctrlKey || e.metaKey) && e.keyCode == 17 || e.keyCode == 224 || e.keyCode == 91) {
            this.masks['ctrl'] = e.keyCode;
        }
        else if (e.altKey && e.keyCode == 18) {
            this.masks['alt'] = e.keyCode;
        }
        else if (e.shiftKey && e.keyCode == 16) {
            this.masks['shift'] = e.keyCode;
        }
        else if (e.shiftKey && e.keyCode == 16) {
            this.masks['shift'] = e.keyCode;
        }
        else {
            this.masks[e.keyCode] = true;
        }
    }
    openSnackBar(message, action = '', type, meta) {
        if (message == null)
            message = '';
        if (action == null)
            action = '';
        this.translate.get([message, action, 'DIALOG.SUCCESS', 'DIALOG.INFO', 'DIALOG.WARNING', 'DIALOG.ERROR'], meta)
            .subscribe(param => {
            let successTitle = param['DIALOG.SUCCESS'];
            let infoTitle = param['DIALOG.INFO'];
            let warningTitle = param['DIALOG.WARNING'];
            let errorTitle = param['DIALOG.ERROR'];
            if (message)
                message = param[message];
            if (action)
                action = param[action];
            if (this.isMobile()) {
                return this.snackBar.open(message, action, {
                    duration: Constants_1.Constants.SNACKBAR_DURATION,
                    panelClass: type ? type : ''
                });
            }
            else if (action) {
                this.snotifyService.confirm(message, {
                    showProgressBar: false,
                    closeOnClick: false,
                    type: this.getSnotifyType(type),
                    buttons: [
                        {
                            text: action, action: (toast) => {
                                this.snotifyService.remove(toast.id);
                            }, bold: true
                        }
                    ]
                });
            }
            else if (type == global_1.Notification.INFO) {
                this.snotifyService.info(message, infoTitle);
            }
            else if (type == global_1.Notification.SUCCESS) {
                this.snotifyService.success(message, successTitle);
            }
            else if (type == global_1.Notification.WARN) {
                this.snotifyService.warning(message, warningTitle);
            }
            else if (type == global_1.Notification.ERROR) {
                this.snotifyService.error(message, errorTitle);
            }
            else {
                this.snotifyService.simple(message);
            }
        });
    }
    getSnotifyType(type) {
        if (type == global_1.Notification.INFO)
            return 'info';
        else if (type == global_1.Notification.SUCCESS)
            return 'success';
        else if (type == global_1.Notification.ERROR)
            return 'error';
        else if (type == global_1.Notification.WARN)
            return 'warning';
        else
            return 'simple';
    }
    openSnackBarInfo(message, action, meta) {
        return this.openSnackBar(message, action, global_1.Notification.INFO, meta);
    }
    openSnackBarSuccess(message, action, meta) {
        return this.openSnackBar(message, action, global_1.Notification.SUCCESS, meta);
    }
    openSnackBarError(message, action, meta) {
        return this.openSnackBar(message, action, global_1.Notification.ERROR, meta);
    }
    openSnackBarWarn(message, action, meta) {
        return this.openSnackBar(message, action, global_1.Notification.WARN, meta);
    }
    openDialog(title, desc, posBtn, negBtn, input, isExternalURL, error) {
        // var d = {title: title, text: desc, posBtn: posBtn, negBtn: negBtn, input: input, isExternalURL: isExternalURL, error: error } ;
        // console.log ( '!!!!!!!!!!!!!!!! incoming !!!!!!!!!!!!!!!!!!!', d ) ;
        let dialogRef = this.dialog.open(app_dialog_1.AppDialog, {
            width: '350px',
            data: { title: title, text: desc, posBtn: posBtn, negBtn: negBtn, input: input, isExternalURL: isExternalURL, error: error }
        });
        return dialogRef.afterClosed();
    }
    openEPSGDialogWith(title, desc, posBtn, negBtn) {
        let dialogRef = this.dialog.open(epsgcode_dialog_component_1.EpsgcodeDialog, {
            width: '65%',
            height: '86%',
            data: { title: title, text: desc, posBtn: posBtn, negBtn: negBtn }
        });
        return dialogRef.afterClosed();
    }
    openMapDialogWithItems(ds, items, title, desc, posBtn, negBtn) {
        let dialogRef = this.dialog.open(map_dialog_1.MapDialog, {
            width: '80%',
            height: '80%',
            data: { title: title, text: desc, posBtn: posBtn, negBtn: negBtn, items: items, dataset: ds }
        });
        return dialogRef.afterClosed();
    }
    openConfirmDelete(cb, name) {
        this.openDialogWithMeta({ deletename: name }, 'GENERIC.DIALOG.DELETE.TITLE', 'GENERIC.DIALOG.DELETE.MSG', 'GENERIC.YES', 'GENERIC.NO').subscribe(s => {
            if (s)
                cb();
        });
    }
    openMapDialogPlotAllWithItems(ds, items, title, selectedFolder, desc, posBtn, negBtn) {
        let dialogRef = this.dialog.open(map_dialog_plot_all_1.MapDialogPlotAll, {
            width: '80%',
            height: '80%',
            data: {
                title: title,
                text: desc,
                posBtn: posBtn,
                negBtn: negBtn,
                items: items,
                dataset: ds,
                selectedFolder: selectedFolder
            }
        });
        return dialogRef.afterClosed();
    }
    openDZIDialogWith(img, title, desc, posBtn, negBtn) {
        let dialogRef = this.dialog.open(map_dialog_1.DZIDialog, {
            width: '65%',
            height: '85%',
            data: { title: title, text: desc, posBtn: posBtn, negBtn: negBtn, img: img }
        });
        return dialogRef.afterClosed();
    }
    openEdgeWarningDialog() {
        if (window.navigator.userAgent.indexOf("MSIE") > -1 || window.navigator.userAgent.indexOf("Trident") > -1 || window.navigator.userAgent.indexOf("Edge") > -1)
            this.openDialog('GENERIC.SWITCH_BROWSER').subscribe();
    }
    /*openMetadataDialogWith(title: string, desc?: string, posBtn?: string, negBtn?: string): Observable<any> {
  
      let dialogRef = this.dialog.open(MetadataDialogComponent, {
        width: '65%',
        height: '80%',
        data: {title: title, text: desc, posBtn: posBtn, negBtn: negBtn}
      });
  
      return dialogRef.afterClosed()
    }*/
    openDialogWithMode(mode, title, desc, posBtn, negBtn, input, width, error) {
        let dialogRef = this.dialog.open(app_dialog_1.AppDialog, {
            width: width ? width : '80%',
            data: { title: title, text: desc, posBtn: posBtn, negBtn: negBtn, input: input, error: error, mode: mode }
        });
        return dialogRef.afterClosed();
    }
    openDialogWithModeAndFilter(mode, filter, title, desc, posBtn, negBtn, input, error) {
        let dialogRef = this.dialog.open(app_dialog_1.AppDialog, {
            width: '80%',
            data: {
                title: title,
                text: desc,
                posBtn: posBtn,
                negBtn: negBtn,
                input: input,
                error: error,
                mode: mode,
                filter: filter
            }
        });
        return dialogRef.afterClosed();
    }
    openDialogWithModeAndFilterAndMeta(meta, mode, filter, title, desc, posBtn, negBtn, input, error) {
        let dialogRef = this.dialog.open(app_dialog_1.AppDialog, {
            width: '80%',
            data: {
                meta: meta,
                title: title,
                text: desc,
                posBtn: posBtn,
                negBtn: negBtn,
                input: input,
                error: error,
                mode: mode,
                filter: filter
            }
        });
        return dialogRef.afterClosed();
    }
    openDialogWithMeta(meta, title, desc, posBtn, negBtn, input, error) {
        let dialogRef = this.dialog.open(app_dialog_1.AppDialog, {
            width: '350px',
            data: { title: title, text: desc, posBtn: posBtn, negBtn: negBtn, input: input, error: error, meta: meta }
        });
        return dialogRef.afterClosed();
    }
    /*
      replace(value: string, params: Array<string>): string {
        params.forEach((element, index) => {
          value = value.replace('$%' + (index + 1), element)
        });
        return value
      }
    */
    // navigation
    navigateToRoute(route) {
        if (this.debug) {
            console.log('%c base.comp [' + this.debugMe + '] %c navigateToRoute()', this.debugPrimary, this.debugSecondary, route);
        }
        this.router.navigateByUrl(route);
    }
    //navigate back to previous location
    navigateBack(location) {
        if (this.debug) {
            console.log('%c base.comp [' + this.debugMe + '] %c navigateBack()', this.debugPrimary, this.debugSecondary);
        }
        location.back();
    }
    goBack() {
        if (this.debug) {
            console.log('%c base.comp [' + this.debugMe + '] %c goBack()', this.debugPrimary, this.debugSecondary);
        }
        window.history.back();
    }
    cancel() {
        if (this.debug) {
            console.log('%c base.comp [' + this.debugMe + '] %c cancel()', this.debugPrimary, this.debugSecondary);
        }
        this.goBack();
    }
    /**
     * Returns true if the screen is mobile size
     */
    isMobile() {
        return this.checkWindowSize() < 770;
    }
    isMobileSmall() {
        return this.currentSize < 500;
    }
    isMobileLarge() {
        return this.currentSize < 1025;
    }
    checkWindowSize() {
        if (this.checkMobileCounter++ > 150) {
            this.checkMobileCounter = 0;
            this.currentSize = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        }
        return this.currentSize;
    }
}
exports.BaseComponent = BaseComponent;
